var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 20,
    viewBox: "0 0 55 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boton",
    transform: "translate(-410 -12.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_43",
    "data-name": "Rect\\xE1ngulo 43",
    width: 55,
    height: 20,
    rx: 10,
    transform: "translate(410 12.4)",
    fill: "#e4ebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(421 19.4)",
    fill: "#aeb0b0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(434 19.4)",
    fill: "#aeb0b0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_13",
    "data-name": "Elipse 13",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(447 19.4)",
    fill: "#aeb0b0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoton);
export default __webpack_public_path__ + "static/media/Boton.26aefd0041a9019397c72659a37c8701.svg";
export { ForwardRef as ReactComponent };